import React, { useEffect, useState } from 'react'
import {Videos} from './allComponent'
import { useParams } from 'react-router-dom';
import { fetchFromAPI } from '../global/Api';

function SearchedResultPage() {
    const [videos, setVideos] = useState(null);

    const {serchedValue}=useParams()
    useEffect(() => {
        fetchFromAPI(`search?part=snippet,id&q=${serchedValue}`)
          .then((data) => setVideos(data.items))
        }, [serchedValue]);
    
  return (
    <div className='container'>
        <Videos videos={videos}  selectedCategory={`you searched about ${serchedValue}`}/>
    </div>
  )
}

export default SearchedResultPage